import type { OtpVerifyFailure } from '@src/components';
import { santaClient } from '@src/state/client';

function attemptsLeftFromError(
  error: { data?: { attemptsLeft?: unknown } } | undefined,
): number | undefined {
  const value = error?.data?.attemptsLeft;
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 ? value : undefined;
}

/** Confirm an email change. Does not navigate — the settings page stays put. */
export async function verifyOtpForSettings(
  challengeToken: string,
  code: string,
): Promise<OtpVerifyFailure | null> {
  const res = await santaClient.verifyNotificationCode({ challengeToken, code });
  if (res.ok) {
    return null;
  }
  const message = res.error?.message;
  if (message === 'NOTIFICATION_ACCESS_CODE_LOCKED') {
    return { key: 'otp.locked' };
  }
  if (message === 'NOTIFICATION_ACCESS_CODE_WRONG') {
    return { key: 'otp.wrong', attemptsLeft: attemptsLeftFromError(res.error) };
  }
  if (message === 'Too many requests' || res.error?.status === 429) {
    return { key: 'otp.rateLimited' };
  }
  return { key: message || 'otp.wrong' };
}
